module.exports = __webpack_public_path__ + "static/media/codepen.6db9549d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/codepen.svg
// module id = 59
// module chunks = 0